import { styled } from '@acko-tech/building-blocks.ui.common';

export const WhyAckoWrapper = styled.div`
    padding: 60px 140px;
    max-width: 1440px;
    margin: auto;
    @media screen and (max-width: 780px) {
        padding: 40px 20px;
    }
`;

export const Title = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 30px;
    line-height: 36px;
    text-align: center;
    color: #434f5a;
    @media screen and (min-width: 780px) {
        margin-bottom: 50px;
    }
    @media screen and (max-width: 780px) {
        font-size: 26px;
        line-height: 31px;
        letter-spacing: 0.02em;
        margin-bottom: 10px;
    }
`;

export const OptionsWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    @media screen and (max-width: 780px) {
        display: flex;
        flex-direction: column;
    }
`;

export const Option = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 20px;
    @media screen and (max-width: 780px) {
        margin: 20px 0;
    }
`;

export const Image = styled.img`
    width: 115px;
    @media screen and (max-width: 780px) {
        width: 86px;
    }
`;

export const OptionHeading = styled.div`
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #282e33;
    margin-top: 18px;
    @media screen and (max-width: 780px) {
        margin-top: 17px;
    }
`;

export const OptionSubHeading = styled.div`
    display: flex;
    justify-content: center;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #434f5a;
    margin-top: 16px;

    @media screen and (max-width: 780px) {
        margin: 0 20px;
    }
`;
